export const useTypePanier = () => {

  const { query } = useRoute();

  const typePanier = computed(() => {
    return query.type_panier || "drive";
  });

  return {
    typePanier
  }
}